import React, { useEffect, useState } from "react";
import bannerImage from "./assets/hero.png";
import detailImage from "./assets/detail.png";
import feature1 from "./assets/feature-1.png";
import feature2 from "./assets/feature-2.png";
import feature3 from "./assets/feature-3.png";
import feature4 from "./assets/feature-4.png";
import logo from "./assets/langusity-logo.png";
import SubscribeNewsletters from "./SubscribeNewsletters/SubscribeNewsletters";
import { LANGUISITY_KEYWORDS } from "../../../_constants/staticData";
import arrow from "../../../assets/images/right-arrow.png";

import "./langusity.scss";

const Langusity = () => {
  const [cardNo, setCardNo] = useState(1);

  useEffect(() => {
    document.head.insertAdjacentHTML(
      "beforeend",
      `<meta name='keywords' content='${LANGUISITY_KEYWORDS}'  />`
    );
  }, []);

  const disableScroll = () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    window.onscroll = function () {
      window.scrollTo(scrollLeft, scrollTop);
    };
    return setTimeout(() => {
      window.onscroll = function () {};
    }, 100);
  };

  return (
    <div className="langusity-container">
      <div className="banner">
        <div className="inner-container">
          <div className="banner-left">
            <div className="header">
              UNDERSTANDING, UNLOCKED
              <div className="brand-logo">
                <img className="logo-image header" src={logo} />{" "}
                <span>ERA BEGINS</span>
              </div>
            </div>
            <div className="">
              <p>
                yslearn has unlocked a new era in knowledge sharing. Languisity
                is the real time solution for webinars.{" "}
              </p>
            </div>
            <div>
              <SubscribeNewsletters buttonTitle="Update me!" variant="header" />
            </div>
          </div>
          <div className="banner-right">
            <img src={bannerImage} />
          </div>
        </div>
      </div>
      <div className="langusity-features">
        <div className="inner-container features">
          <h1>MAIN FEATURES</h1>
          <div className="features-container">
            <div id="1" className="feature">
              <div className="feature-1">
                <img src={feature1} />
              </div>
              <h4 className="feature-title">EMPOWERING</h4>
              <p className="description">
                Languisity empowers personal choice while supporting
                international teams. Webinar participants choose between
                English, Hindi, Arabic, Spanish and French automated
                translations.
              </p>
            </div>
            <div id="2" className="feature">
              <div className="feature-2">
                <img src={feature2} />
              </div>
              <h4 className="feature-title">INCLUSIVITY</h4>
              <p className="description">
                Languisity removes language barriers to sharing ideas and
                collaborating. It makes online learning more inclusive than ever
                before.
              </p>
            </div>
            <div id="3" className="feature">
              <div className="feature-3">
                <img src={feature3} />
              </div>
              <h4 className="feature-title">SIMULTANEOUS</h4>
              <p className="description">
                Languisity brings simultaneous translations to yslearn’s live
                webinars. Participants choose between text captions and audio
                for instant language interpretations.
              </p>
            </div>
            <div id="4" className="feature">
              <div className="feature-4">
                <img src={feature4} />
              </div>
              <h4 className="feature-title">EXCLUSIVITY</h4>
              <p className="description">
                Languisity is the multilingual communications tool exclusively
                for educational uses. Used for real time training, or to review
                recordings for replay, the translation tool is ready on demand.
              </p>
            </div>
          </div>
          <div className="arrow-btn-div">
            <a href={`#${cardNo}`} onClick={disableScroll}>
              <img
                src={arrow}
                onClick={() => setCardNo(cardNo === 1 ? 1 : cardNo - 1)}
                className={
                  cardNo === 1
                    ? "languisity-forward-arrow disable"
                    : "languisity-forward-arrow"
                }
              />
            </a>
            <a href={`#${cardNo}`} onClick={disableScroll}>
              <img
                src={arrow}
                onClick={() => setCardNo(cardNo === 4 ? 4 : cardNo + 1)}
                className={
                  cardNo === 4
                    ? "languisity-backward-arrow disable"
                    : "languisity-backward-arrow"
                }
              />
            </a>
          </div>
        </div>
      </div>
      <div className="langusity-detail">
        <div className="inner-container details">
          <div className="detail-left">
            <img src={detailImage} />
          </div>
          <div className="detail-right">
            <div className="title">
              <img className="logo-image" src={logo} />
              <span>IN DETAIL</span>
            </div>
            <p className="descrition">
              Languisity is the seamless communications tool instructors and
              learners have been waiting for. Through Languisity real time
              translations are available exclusively for yslearn’s webinars.
              Participants from around the world can finally contribute to
              discussion in their own languages and be heard by others in
              theirs. No advance planning is required. No interpreters need to
              be scheduled. Learners have the full flexibility to show up and
              select their language of preference. Languisity is launching with
              English, Hindi, Arabic, Spanish and French automated translations.
              Plans to add more languages are underway.
            </p>
            <ul>
              <li>
                Offer choice and flexibility with text or audio in five
                languages
              </li>
              <li>Make education more inclusive</li>
              <li>Remove language barriers to sharing and collaboration</li>
              <li>
                Empower your learning environment with real time translation
                options
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="langusity-footer">
        <div className="inner-container footer">
          <div className="footer-left">
            BE AMONG THE FIRST TO TRY LANGUISITY.
            <div>
              <h3>
                <b>SUBSCRIBE FOR UPDATES.</b>
              </h3>
            </div>
          </div>
          <div className="footer-right">
            <SubscribeNewsletters buttonTitle="Notify Me" variant="footer" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Langusity;
